<template>
  <div>
    <div class="max-w-5xl mx-auto">
      <Projects :product-id="basicProductId" />
    </div>
  </div>
</template>

<script>
import Projects from 'Components/ProductProjects/Projects.vue';

export default {
  components: {
    Projects,
  },
  props: {
    basicProductId: {
      type: String,
      required: true,
    },
  },
};
</script>
